import { createActionTypes } from "@helpers/redux-helpers";

export const getContentRequestMockDataActionTypes = createActionTypes(
  "content-request/get/mock-data",
);

export const setContentRequestFormActionType = "content-request/set/form";

export const contentRequestModalType = "content-request/modal";
